import React, { useMemo } from 'react';
import { FontSizeOption } from '../../../../types/display';
import { Card, CardContent } from "@/components/ui/card";

interface PreviewProps {
  data: any;
  showDescriptions: boolean;
  fontSize: FontSizeOption;
  selectedSections: string[];
  displayOptions: {
    showTitle: boolean;
    showDescription: boolean;
    showItems: boolean;
    showColumns: boolean;
  };
}

const Preview: React.FC<PreviewProps> = ({
  data,
  showDescriptions,
  fontSize,
  selectedSections,
  displayOptions
}) => {
  const filteredData = useMemo(() => {
    if (!data || !data.sections) return [];
    
    if (selectedSections.length === 0 || selectedSections.includes('all')) {
      return data.sections;
    }
    
    return data.sections.filter((section: any) => 
      selectedSections.includes(section.type)
    );
  }, [data, selectedSections]);

  const fontSizeClass = useMemo(() => {
    switch (fontSize) {
      case 'sm': return 'text-sm';
      case 'md': return 'text-base';
      case 'lg': return 'text-lg';
      case 'xl': return 'text-xl';
      default: return 'text-base';
    }
  }, [fontSize]);

  return (
    <div className="preview-container space-y-4">
      {displayOptions.showTitle && data.title && (
        <h2 className={`text-2xl font-bold text-center ${fontSizeClass}`}>
          {data.title}
        </h2>
      )}
      {displayOptions.showDescription && data.description && (
        <p className={`text-gray-600 text-center ${fontSizeClass}`}>
          {data.description}
        </p>
      )}
      {displayOptions.showItems && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {filteredData.map((item: any, index: number) => (
            <Card key={index} className="bg-synagogue-light border-synagogue-border hover:border-synagogue-primary transition-colors">
              <CardContent className="p-4">
                <h3 className={`font-bold mb-2 ${fontSizeClass}`}>{item.type}</h3>
                {item.title && item.title !== item.type && (
                  <p className={`text-gray-600 mb-2 ${fontSizeClass}`}>{item.title}</p>
                )}
                {showDescriptions && item.chapter && (
                  <p className={`text-gray-500 ${fontSizeClass}`}>{item.chapter}</p>
                )}
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default Preview; 